// Copyright (c) 2023-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";
import { ProductTableItemModel } from "../../../../../../../io/hyperify/core/store/types/product/ProductTableItemModel";
import { TranslationParams } from "../../../../../../../io/hyperify/core/types/TranslationParams";
import { createSendanorSeoImageData, SendanorSeoImageData } from "../../../../../core/types/SendanorSeoImageData";
import {
    T_COMMON_PRICE_EUR_LINE_2,
    T_COMMON_PRICE_WITH_PERIOD_EUR,
    T_DATE_TIME_FORMAT,
    T_DISCOUNT_PRICE_EUR_LINE_2,
    T_DISCOUNT_PRICE_EUR_LINE_3,
    T_DISCOUNT_PRICE_WITH_PERIOD_EUR
} from "../../../../../core/constants/translation";
import { SendanorProductUtils } from "../../../../../core/utils/SendanorProductUtils";

export function getSeoDataFromProductTableItem (
    t: TranslationFunction,
    item: ProductTableItemModel | undefined,
    tagLine: string | undefined,
    buttonLabel: string | undefined,
    mainTitle: string | undefined,
    extraInfo: string | undefined,
    displayPrice : boolean = true,
    extraTranslationParams ?: TranslationParams,
    seoDescription ?: string | undefined,
): SendanorSeoImageData {
    const dateTimeFormat = t( T_DATE_TIME_FORMAT, extraTranslationParams );
    const productTranslationParams = SendanorProductUtils.createTranslationParamsFromPrice(
        item?.priceModel,
        dateTimeFormat,
        t,
    );
    const translationParams = {
        ...extraTranslationParams,
        ...productTranslationParams,
    };
    const productTitle = item?.title ?? '';
    return createSendanorSeoImageData(
        mainTitle ? t(mainTitle, translationParams) : undefined,
        `${
            productTitle && (productTitle !== mainTitle) ? t(productTitle, translationParams) + ' ' : ''
        }${
            seoDescription ? t(seoDescription, translationParams) : t(item?.description ?? '', translationParams) 
        }`,
        displayPrice ? `${
            !productTranslationParams.DISCOUNT ? (
                t(
                    T_COMMON_PRICE_WITH_PERIOD_EUR,
                    translationParams
                ) + '\n' + t(
                    T_COMMON_PRICE_EUR_LINE_2,
                    translationParams
                )
            ) : (
                t(
                    T_DISCOUNT_PRICE_WITH_PERIOD_EUR,
                    translationParams
                ) + '\n' + t(
                    T_DISCOUNT_PRICE_EUR_LINE_2,
                    translationParams
                )
            )
        }` : undefined,
        buttonLabel ? t(buttonLabel, translationParams) : undefined,
        !productTranslationParams.DISCOUNT ? undefined : t(
            T_DISCOUNT_PRICE_EUR_LINE_3,
            translationParams
        ),
        extraInfo ? t(extraInfo, translationParams) : undefined,
        tagLine ? t(tagLine, translationParams) : undefined,
    );

}
